import { Link } from 'react-router-dom';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import './TasksItem.css';

export default function TasksItem({ task, section, backgroundStyle }) {


  return (
    <div className={`TasksItem ${backgroundStyle? backgroundStyle:''}`}>
        { section === 'leads' &&
        <>
            <div className='taskOwner' data-bs-dismiss="modal">
                <Link to={`/leads/${task.leadID}`}>
                    {capitalizeFirstLetter(task.leadName)}
                </Link>
            </div>
            <div className='taskTitle'>{task.title}</div>
            <div className={`taskPriority ${task.priority}`}>
                <div className={`priorityContainer ${task.priority}`}>
                    <span className={`priorityColor ${task.priority}`}></span>
                    { task.priority === 'low' &&
                    <span className={`priorityText ${task.priority}`}>Low</span>
                    }
                    { task.priority === 'medium' &&
                    <span className={`priorityText ${task.priority}`}>Medium</span>
                    }
                    { task.priority === 'high' &&
                    <span className={`priorityText ${task.priority}`}>High</span>
                    }
                </div>
            </div>
            <div className={`taskDeadline`}>
                <div className={`${backgroundStyle==='deadlineWarning'&& 'focusDeadline'}`}>
                    {new Date(task.deadline).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })}
                </div>
            </div>
            <div className='assignedTo'>{capitalizeFirstLetter(task.assignedTo)}</div>
        </>
        }
    </div>
  )
}
